<template>
  <div >
    <card @pagSearch="distributorSearch" :cardData="{title:'各分销商销售情况',type:'table', data:distributorData, key:distributorKey}"></card>
  </div>
</template>

<script>
import { distributorSaleInfo } from 'api'
import card from 'components/card'
    export default {
      data(){
        return {
          distributorKey:['name', 'salesAmount', 'commission', 'paidOrderCount', 'paidUserCount'],
          distributorData:{}
        }
      },
      components:{
        card
      },
      computed: {
        
      },
      mounted(){
        this.distributorSearch()
      },
      methods:{
        distributorSearch(){
          let vis = this
          distributorSaleInfo(arguments[0]).then(res=>{
            if(res.ret ==0){
              vis.distributorData = res.data
            }
          }).catch(()=>{})
        },
      }
    }
</script>

<style lang="scss" scoped>

</style>






// WEBPACK FOOTER //
// distributorData.vue?0d2b2938